// extracted by mini-css-extract-plugin
export default {"btn-detail":"OrderTracking_btn-detail__b6OpY","status-transport":"OrderTracking_status-transport__8ZTr2"};